var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmphrBtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1487_1503)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_1487_1503)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.70876 5.0941C9.27276 1.8349 14.7352 1.8349 18.3004 5.0941L18.9592 4.4353C15.0256 0.8077 8.96676 0.8077 5.03436 4.4353L5.70876 5.0941ZM19.5689 5.03672L18.9101 5.69552C22.1693 9.26072 22.1693 14.7219 18.9101 18.2871L19.5689 18.9459C23.1953 15.0123 23.1953 8.95472 19.5689 5.02112V5.03672ZM5.09379 5.70848C1.83819 9.27248 1.83819 14.7301 5.09379 18.2929L4.43499 18.9733C0.807395 15.0409 0.807395 8.98328 4.43499 5.04968L5.09379 5.70848ZM18.2929 18.9012C14.7289 22.1616 9.26654 22.1616 5.70254 18.9012L5.04254 19.5612C8.97614 23.1876 15.0349 23.1876 18.9673 19.5612L18.2929 18.9012ZM11.478 11.4824C12.2738 11.4964 13.9967 11.5268 13.9967 10.3219C13.9967 9.08899 12.329 9.13237 11.5172 9.15348C11.4267 9.15583 11.3468 9.15791 11.2811 9.15791V11.4799C11.3372 11.4799 11.4035 11.4811 11.478 11.4824ZM11.5037 15.2046C12.4537 15.2185 14.5343 15.2488 14.5343 13.9267C14.5343 12.5743 12.5404 12.6196 11.5652 12.6417C11.4553 12.6442 11.3584 12.6464 11.2787 12.6463V15.2023C11.3432 15.2023 11.4189 15.2034 11.5037 15.2046ZM13.3415 7.82351C14.8427 7.96511 16.0283 8.42591 16.1603 9.80111C16.2611 10.8067 15.8375 11.4115 15.1631 11.7535C16.2719 12.0199 16.9667 12.6787 16.8275 14.1547C16.6571 15.9895 15.2903 16.4719 13.3307 16.5919V18.5059H12.1691V16.6063H11.2427V18.5155H10.0823V16.5775H9.25189H7.74109L7.97149 15.1927C7.97149 15.1927 8.82949 15.2047 8.81509 15.1927C8.92429 15.1987 9.03229 15.1627 9.11509 15.0919C9.19669 15.0187 9.24709 14.9167 9.25429 14.8075V9.58631C9.20749 9.26711 8.91589 9.04151 8.59549 9.07631C8.60869 9.06071 7.75189 9.07631 7.75189 9.07631V7.83551H9.36349H10.1015V5.92871H11.2547V7.79711C11.5655 7.78751 11.8763 7.78751 12.1823 7.78751V5.92871H13.3415V7.82351Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1487_1503",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F50D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7002B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1487_1503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmphrBtc);
export default __webpack_public_path__ + "static/media/amphrBTC.89d24b2faa78353fb07e1eeda9d170d8.svg";
export { ForwardRef as ReactComponent };